import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.function.name";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
export default {
  name: 'JTreeDict',
  data: function data() {
    return {
      treeData: [],
      treeValue: "",
      url_root: "/sys/category/loadTreeRoot",
      url_children: "/sys/category/loadTreeChildren",
      url_view: '/sys/category/loadOne'
    };
  },
  props: {
    value: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      default: '请选择',
      required: false
    },
    parentCode: {
      type: String,
      default: '',
      required: false
    },
    field: {
      type: String,
      default: 'id',
      required: false
    },
    root: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          pid: '0'
        };
      }
    },
    async: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  watch: {
    root: {
      handler: function handler(val) {
        console.log("root-change", val);
      },
      deep: true
    },
    parentCode: {
      handler: function handler() {
        this.loadRoot();
      }
    },
    value: {
      handler: function handler() {
        this.loadViewInfo();
      }
    }
  },
  created: function created() {
    this.loadRoot();
    this.loadViewInfo();
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {
    loadViewInfo: function loadViewInfo() {
      var _this = this;

      if (!this.value || this.value == "0") {
        this.treeValue = "";
      } else {
        var param = {
          field: this.field,
          val: this.value
        };
        getAction(this.url_view, param).then(function (res) {
          if (res.success) {
            _this.treeValue = {
              value: _this.value,
              label: res.result.name
            };
          }
        });
      }
    },
    loadRoot: function loadRoot() {
      var _this2 = this;

      var param = {
        async: this.async,
        pcode: this.parentCode
      };
      getAction(this.url_root, param).then(function (res) {
        if (res.success) {
          _this2.handleTreeNodeValue(res.result);

          console.log("aaaa", res.result);
          _this2.treeData = _toConsumableArray(res.result);
        } else {
          _this2.$message.error(res.message);
        }
      });
    },
    asyncLoadTreeData: function asyncLoadTreeData(treeNode) {
      var _this3 = this;

      return new Promise(function (resolve) {
        if (!_this3.async) {
          resolve();
          return;
        }

        if (treeNode.$vnode.children) {
          resolve();
          return;
        }

        var pid = treeNode.$vnode.key;
        var param = {
          pid: pid
        };
        getAction(_this3.url_children, param).then(function (res) {
          if (res.success) {
            _this3.handleTreeNodeValue(res.result);

            _this3.addChildren(pid, res.result, _this3.treeData);

            _this3.treeData = _toConsumableArray(_this3.treeData);
          }

          resolve();
        });
      });
    },
    addChildren: function addChildren(pid, children, treeArray) {
      if (treeArray && treeArray.length > 0) {
        var _iterator = _createForOfIteratorHelper(treeArray),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.key == pid) {
              if (!children || children.length == 0) {
                item.leaf = true;
              } else {
                item.children = children;
              }

              break;
            } else {
              this.addChildren(pid, children, item.children);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    },
    handleTreeNodeValue: function handleTreeNodeValue(result) {
      var storeField = this.field == 'code' ? 'code' : 'key';

      var _iterator2 = _createForOfIteratorHelper(result),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var i = _step2.value;
          i.value = i[storeField];
          i.isLeaf = !i.leaf ? false : true;

          if (i.children && i.children.length > 0) {
            this.handleTreeNodeValue(i.children);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    },
    onChange: function onChange(value) {
      console.log(value);
      this.$emit('change', value.value);
      this.treeValue = value;
    },
    onSearch: function onSearch(value) {
      console.log(value);
    },
    getCurrTreeData: function getCurrTreeData() {
      return this.treeData;
    }
  }
};